module.exports = __webpack_public_path__ + "img/no_3.da15af90.png";